import gtm from 'eco-design-reliance/gtm';
import { ItfGTM69Entire, ItfGTM69 } from './type';

// https://docs.google.com/spreadsheets/d/11MquSBS3Lo7WJsZg_bbcDfNOefHKrr0P_YgD7qeBGFQ/edit?pli=1&gid=370435365#gid=370435365
// 【No4.用户行为】Sheet
export const handle_GTM_69 = (data: ItfGTM69) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'banner_switch' } as ItfGTM69Entire);
};
